var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKaspiError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 90C0 139.706 40.2944 180 90 180C139.706 180 180 139.706 180 90C180 40.2944 139.706 0 90 0C40.2944 0 0 40.2944 0 90ZM171.325 89.9999C171.325 134.915 134.915 171.325 89.9999 171.325C45.0852 171.325 8.67464 134.915 8.67464 89.9999C8.67464 45.0852 45.0852 8.67459 89.9999 8.67459C134.915 8.67459 171.325 45.0852 171.325 89.9999Z",
    fill: "black",
    fillOpacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.0002 147.47C121.74 147.47 147.47 121.74 147.47 89.9999C147.47 58.2602 121.74 32.53 90.0002 32.53C58.2604 32.53 32.5303 58.2602 32.5303 89.9999C32.5303 121.74 58.2604 147.47 90.0002 147.47ZM110.957 71.5145C111.658 70.8132 111.658 69.676 110.957 68.9747C110.256 68.2733 109.119 68.2733 108.417 68.9747L89.9662 87.4258L71.5153 68.9749C70.814 68.2735 69.6768 68.2735 68.9755 68.9749C68.2741 69.6762 68.2741 70.8134 68.9755 71.5147L87.4264 89.9656L68.9748 108.417C68.2734 109.119 68.2734 110.256 68.9748 110.957C69.6762 111.658 70.8133 111.658 71.5146 110.957L89.9662 92.5054L108.418 110.957C109.119 111.659 110.256 111.659 110.958 110.957C111.659 110.256 111.659 109.119 110.958 108.417L92.506 89.9656L110.957 71.5145Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaspiError);
export default __webpack_public_path__ + "static/media/kaspi-error.f7ffd15bee972e71e8e8adf0fc3440f8.svg";
export { ForwardRef as ReactComponent };